import React, { useEffect, useContext, useState, useMemo } from 'react';
import Badge from '../../../components/base/Badge';
import { useAppContext } from '../../../providers/AppProvider';
import RevealDropdown, {
  RevealDropdownTrigger
} from '../../../components/base/RevealDropdown';
import { useMainLayoutContext } from '../../../providers/MainLayoutProvider';
import { Col, Dropdown, Row } from 'react-bootstrap';
import { UilStopwatch } from '@iconscout/react-unicons';
import ActivityTimeline from '../../../components/timelines/ActivityTimeline';
import MachineMaxSpeedAndLinearSpeed from '../../../components/charts/machines-charts/MachineMaxSpeedAndLinearSpeed';
import MachineSpeedGauge from '../../../components/charts/machines-charts/MachineSpeedGauge';
import MachineTotalMetersChart from '../../../components/charts/machines-charts/MachineTotalMetersChart';
import FlipNumber from '../../../components/cards/FlipNumber';
import MachineTraverseChart from '../../../components/charts/machines-charts/MachineTraverseChart';
import { MachineDataContext } from '../../../providers/MachineDataContext';
import MachineCarrierChart from '../../../components/charts/machines-charts/MachineCarrierChart';
import { FallingLines } from 'react-loader-spinner';
import Ach300CounterSetCounter from './Ach300CounterSetCounter';
import getShiftStartEndTime, {
  updateTimeRange
} from '../../../components/charts/utils/chartUtils';
import MachimeTime from '../../../components/cards/MachimeTime';
import MachineTotalProduction from '../../../components/charts/machines-charts/MachineTotalProduction';
import ACH300TOTALPRODUCTION from '../../../components/charts/machines-charts/ACH300TOTALPRODUCTION';
import ActiveBreakTimeBarChart from '../../../components/charts/machines-charts/ActiveBreakTimeBarChart.js';
import MachinePercentageLineChart from '../../../components/charts/machines-charts/MachinePercentageLineChart.js';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faAngleRight,
  faChevronLeft,
  faChevronRight
} from '@fortawesome/free-solid-svg-icons';
import dayjs from 'dayjs';
import isBetween from 'dayjs/plugin/isBetween';
import DisplayShift from '../../../components/base/DisplayShift.js';
import LazyLoadChart from '../../../components/common/LazyLoadChart.js';
import SparkTesterChart from '../../../components/charts/machines-charts/SparkTesterChart.js';
import SparkTesterPieces from '../../../components/cards/SparkTesterPieces.js';
import SparkTesterStatus from '../../../components/base/SparkTesterStatus.js';
import { WebSocketContext } from '../../../providers/WebSocketProvider.js';
import '../../../components/machines/trackingHeader.css';
const Ach300Traking = () => {
  const { setContentClass } = useMainLayoutContext();

  const { machineSingle, subscribeToChannel, unsubscribeToChannel } =
    useContext(WebSocketContext);

  // Memoize reversed reports with a fallback for undefined reports
  const reversedReports = useMemo(
    () =>
      machineSingle?.state?.reports
        ? machineSingle.state.reports.slice().reverse()
        : [],
    [machineSingle?.state?.reports]
  );

  const initialShiftTimes = getShiftStartEndTime();

  const currentDay = dayjs();

  // State for startTime and endTime
  const [timeRange, setTimeRange] = useState({
    startTime: initialShiftTimes.startTime,
    endTime: initialShiftTimes.endTime
  });

  const { startTime, endTime } = timeRange;
  const isWithinShift = currentDay.isBetween(
    dayjs(timeRange.startTime),
    dayjs(timeRange.endTime)
  );

  // Function to update the time range by a specific amount

  const handleUpdate = direction => {
    const { startTime, endTime } = updateTimeRange(timeRange, direction);
    setTimeRange(prevRange => ({
      startTime,
      endTime
    }));
  };

  const {
    config: { theme },
    getThemeColor
  } = useAppContext();

  useEffect(() => {
    setContentClass('px-0 pt-navbar');

    return () => {
      setContentClass('');
    };
  }, []);

  useEffect(() => {
    console.log('Subscribing to machine-all channel');
    subscribeToChannel('machine-single', 'ach300');

    return () => {
      console.log('UNSUBSCRIBING from machine-all channel');
      unsubscribeToChannel();
    };
  }, []);

  if (!machineSingle || machineSingle.machine !== 'ach300') {
    return (
      <div style={styles.spinnerContainer}>
        <FallingLines
          color={theme === 'dark' ? 'white' : '#3874ff'}
          width="100"
          visible={true}
          ariaLabel="falling-circles-loading"
          // wrapperStyle ={styles.spinnerContainer}
        />
      </div>
    );
  }

  return (
    <Row className="g-0">
      <Col xs={12} xxl={isWithinShift ? 8 : 12} className="px-0 bg-soft">
        <div className="px-4 px-lg-6 pt-6 pb-9">
          <div className="mb-5">
            <div className="tracking-header">
              {/* Machine Overview */}
              <h2 className="text-black fw-bolder mb-2 tracking-header__title">
                Machine Ach-300 overview
              </h2>

              {/* Timeline: Center-aligned */}
              <div
                className="d-flex align-items-center mx-auto"
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '10px'
                }}
              >
                <button
                  className="btn btn-link p-0"
                  aria-label="Previous date"
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: '40px',
                    height: '40px',
                    border: 'none',
                    borderRadius: '50%',
                    cursor: 'pointer',
                    transition:
                      'transform 0.3s ease, background-color 0.3s ease'
                  }}
                  onMouseEnter={e => {
                    e.target.style.backgroundColor = '#004DFF';
                    theme === 'dark'
                      ? (e.target.style.color = 'white')
                      : (e.target.style.color = 'black');
                  }}
                  onMouseLeave={e =>
                    (e.target.style.backgroundColor = 'transparent')
                  }
                  onClick={() => {
                    console.log('LEFT CLICK');
                    handleUpdate(-1);
                  }} // Decrease by 12 hours
                >
                  <FontAwesomeIcon
                    icon={faChevronLeft}
                    style={{
                      fontSize: '16px',
                      transition: 'transform 0.3s ease'
                    }}
                  />
                </button>
                <span
                  style={{
                    fontSize: '16px',
                    fontWeight: 'bold',
                    textAlign: 'center'
                  }}
                >
                  {dayjs(startTime).format('MMMM D, YYYY, h:mm A')}
                </span>
                <button
                  className="btn btn-link p-0"
                  aria-label="Next date"
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: '40px',
                    height: '40px',
                    border: 'none',
                    backgroundColor: 'transparent',
                    borderRadius: '50%',
                    cursor: 'pointer',
                    transition:
                      'transform 0.3s ease, background-color 0.3s ease'
                  }}
                  onMouseEnter={e => {
                    e.target.style.backgroundColor = '#004DFF';
                    theme === 'dark'
                      ? (e.target.style.color = 'white')
                      : (e.target.style.color = 'black');
                  }}
                  onMouseLeave={e =>
                    (e.target.style.backgroundColor = 'transparent')
                  }
                  onClick={() => {
                    handleUpdate(1);
                    console.log('RIGHT CLICK');
                  }} // Increase by 12 hours
                >
                  <FontAwesomeIcon
                    icon={faChevronRight}
                    style={{
                      fontSize: '16px',
                      transition: 'transform 0.3s ease'
                    }}
                  />
                </button>
              </div>

              {/* Shift */}
              {/* Right half — sizing lives in trackingHeader.css */}
              <div className="tracking-header__aside">
                <DisplayShift
                  machineName={'ach300'}
                  bucket={'machine_data'}
                  startTime={startTime}
                  endTime={endTime}
                />

                <RevealDropdownTrigger>
                  <RevealDropdown>
                    <Dropdown.Item>Edit</Dropdown.Item>
                    <Dropdown.Item className="text-danger">Delete</Dropdown.Item>
                    <Dropdown.Item>Download</Dropdown.Item>
                    <Dropdown.Item>Report abuse</Dropdown.Item>
                  </RevealDropdown>
                </RevealDropdownTrigger>
              </div>
            </div>
            {isWithinShift && (
              <div className="d-flex justify-content-between align-items-center mt-3">
                <Badge
                  variant="phoenix"
                  bg={machineSingle.state.status?.type}
                  iconPosition="end"
                  icon={<UilStopwatch size={12} className="ms-1" />}
                >
                  {machineSingle.state.status?.label}
                </Badge>

                <SparkTesterStatus
                  sparkStatus={machineSingle.state.currentPlcState.SPARK_ON_OFF}
                />
              </div>
            )}
          </div>
          <Row className="gx-0 gx-sm-5 gy-8 mb-8">
            <Col xs={12} sm={12} lg={12} xl={12} xxl={12}>
              <LazyLoadChart>
                <ACH300TOTALPRODUCTION
                  bucket={'machine_data'}
                  machineName={'ach300'}
                  startTime={startTime}
                  endTime={endTime}
                />
                {/* <MachineTotalProduction
                  bucket={'machine_data'}
                  machineName={'ach300'}
                  startTime={startTime}
                  endTime={endTime}
                /> */}
              </LazyLoadChart>
            </Col>

            <Col xs={12} xl={6} xxl={6} className="pe-xl-0">
              {/* Number of Coils produced */}
              <LazyLoadChart>
                <MachimeTime
                  bucket={'machine_data'}
                  machineName={'ach300'}
                  time={'totalActiveTime'}
                  startTime={startTime}
                  endTime={endTime}
                  title={'Active Machine Minutes'}
                />
              </LazyLoadChart>
            </Col>
            <Col xs={12} xl={6} xxl={6} className=" pe-xl-0">
              {/* Number of Coils produced */}
              <LazyLoadChart>
                <MachimeTime
                  bucket={'machine_data'}
                  machineName={'ach300'}
                  time={'totalBreakTime'}
                  startTime={startTime}
                  endTime={endTime}
                  title={'Break Machine Minutes'}
                />
              </LazyLoadChart>
            </Col>

            <Col xs={12} xl={12} xxl={12} className="pe-xl-0">
              {/* Number of Coils produced */}
              <LazyLoadChart>
                <ActiveBreakTimeBarChart
                  dynamicBucket={'true'}
                  bucket={'machine_data_30minute'}
                  machineName={'ach300'}
                  fields={'ACTIVE_TIME,BREAK_TIME'}
                  startTime={startTime}
                  endTime={endTime}
                  title={'Active Break Time'}
                />
              </LazyLoadChart>
            </Col>

            <Col xs={12} sm={12} lg={12} xl={12} xxl={12}>
              {/* TOTAL METER PRODUCED */}
              <LazyLoadChart>
                <MachineTotalMetersChart
                  dynamicBucket={'true'}
                  bucket={'machine_data_minute'}
                  machineName={'ach300'}
                  fields={'total_produced'}
                  startTime={startTime}
                  endTime={endTime}
                />
              </LazyLoadChart>
            </Col>

            <Col xs={12} xl={12} xxl={12} className="pe-xl-0">
              {/* METER MAX OVER TIME  */}
              <LazyLoadChart>
                <Ach300CounterSetCounter
                  bucket={'machine_data_30second'}
                  machineName={'ach300'}
                  fields={'METER_ACT,METER_SET'}
                  startTime={startTime}
                  endTime={endTime}
                />
              </LazyLoadChart>
            </Col>
            <Col xs={12} xl={3} xxl={4} className="pe-xl-0">
              {/* LINE SPEED  GAUGE  */}
              {isWithinShift && (
                <MachineSpeedGauge
                  name={'Line Speed'}
                  speed={machineSingle.state.currentPlcState?.ACT_LINE_SPEED.toFixed(
                    2
                  )}
                />
              )}
            </Col>
            <Col xs={12} xl={9} xxl={isWithinShift ? 8 : 12}>
              {/* MAX SPEED LINIEAR SPEED */}
              <LazyLoadChart>
                <MachineMaxSpeedAndLinearSpeed
                  dynamicBucket={'true'}
                  bucket={'machine_data_minute'}
                  machineName={'ach300'}
                  fields={'SET_SPEED,ACT_LINE_SPEED'}
                  startTime={startTime}
                  endTime={endTime}
                />
              </LazyLoadChart>
            </Col>
            <Col xs={12} xl={12} xxl={12}>
              {/* ETALARE  */}
              <LazyLoadChart>
                <MachineTraverseChart
                  bucket={'machine_data_minute'}
                  machineName={'ach300'}
                  fields={'TRAVERSE_SUPERIOR_LIMIT,TRAVERSE_INFERIOR_LIMIT,TRAVER_ACT_POS'}
                  startTime={startTime}
                  endTime={endTime}
                />
              </LazyLoadChart>
            </Col>
            <Col xs={12} xl={12} xxl={12}>
              {/* FOARFECA  */}
              <LazyLoadChart>
                <MachineCarrierChart
                  bucket={'machine_data_minute'}
                  machineName={'ach300'}
                  fields={'Forverder_Act_Pos,Forverder_Right_Limit,Forverder_Left_Limit'}
                  startTime={startTime}
                  endTime={endTime}
                />
              </LazyLoadChart>
            </Col>
            <Col xs={12} xl={12} xxl={12}>
              {/* FOARFECA  */}
              <LazyLoadChart>
                <MachinePercentageLineChart
                  bucket={'machine_data_minute'}
                  title={'Winding RPM'}
                  machineName={'ach300'}
                  fields={'WINDING_ACT_RPM'}
                  startTime={startTime}
                  endTime={endTime}
                />
              </LazyLoadChart>
            </Col>
          </Row>
        </div>
      </Col>
      {isWithinShift ? (
        <Col xs={12} xxl={4} className="px-0 border-start-xxl border-300">
          <div className="border-bottom border-300">
            <div className="bg-light dark__bg-1100 h-100">
              <div className="p-4 p-lg-6">
                <h3 className="text-1000 mb-4 fw-bold">Recent activity</h3>
                <ActivityTimeline reports={reversedReports} />
              </div>
            </div>
          </div>
        </Col>
      ) : (
        ''
      )}
    </Row>
  );
};
const styles = {
  spinnerContainer: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    // backgroundColor: 'rgba(0, 0, 0, 0.5)', // Optional: Add a background with some opacity
    zIndex: 1000 // Ensure the spinner is on top
    // backgroundColor: '#000', // Optional: background color
  }
};
export default Ach300Traking;
